module.exports = __webpack_public_path__ + "static/internacionalismo-c9bc737d968174ad50a183d757414203.png";